import axios from 'axios'
import router from '../../router'

/**
 * initial state
 */
const state = () => ({
  // todo
})

/**
 * getters
 */
const getters = {
  // todo
}

/**
 * mutations
 */
const mutations = {
  // todo
}

/**
 * actions
 */
const actions = {
  /**
   * List Quotation
   */
  /**
   * List Quotation
   */
  listQuotation(context, credentials) {
    return new Promise((resolve, reject) => {
      console.log('API Fire list params ::', credentials)
      axios
        .post(process.env.VUE_APP_FIRE_HISTORY_LIST, credentials)
        .then((response) => {
          if (response.status == 200 && response.data.isSuccess == true) {
            resolve(response.data.data)
          }
        })
        .catch((error) => reject(error))
    })
  },
  /**
   * View Quotation Detail
   * @param paTamjaiId
   * @return {array}
   */
  viewQuotationDetail(context, credentials) {
    return new Promise((resolve, reject) => {
      axios
        .get(process.env.VUE_APP_FIRE_DETAIL + '/' + credentials.fire_insurance_id)
        .then((response) => {
          console.log('API view quotation detail ::', response)
          if (response.status == 200) {
            if (response.data.isSuccess) {
              if (response.data.data.id == null) {
                resolve('No content')
                console.error('No content')
                router.push({ name: 'fire-insurance-index' })
              }
              resolve(response.data.data)
            } else {
              reject(response.data.message)
            }
          } else reject(response.data)
        })
        .catch((error) => {
          console.log(error)
          reject(error)
        })
    })
  },

  reportFire(context, credential) {
    return new Promise((resolve, reject) => {
      // console.log('report cia params ::', credential)
      const params = {
        startDate: credential.startDate,
        endDate: credential.endDate,
      }
      console.log('report Fire params ::', params)
      axios
        .post(process.env.VUE_APP_FIRE_EXPORT_REPORT, params, {
          responseType: 'blob',
        })
        .then((res) => resolve(res))
        .catch((err) => reject(err))
    })
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
